import React from "react";

interface MediaPreviewProps {
  src?: string | string[] | { url?: string } | null;
  alt?: string;
  className?: string;
  poster?: string;
  autoPlay?: boolean;
}

const videoFormats = [".mp4", ".mov", ".webm", ".ogg", ".mkv"];
const imageFormats = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg"];

function normalizeSrc(src: MediaPreviewProps["src"]): string {
  if (!src) return "";
  if (typeof src === "string") return src;
  if (Array.isArray(src) && src.length > 0 && typeof src[0] === "string")
    return src[0];
  if (
    typeof src === "object" &&
    src !== null &&
    "url" in src &&
    typeof src.url === "string"
  )
    return src.url;
  return "";
}

function hasExtension(url: string, exts: string[]) {
  const lower = url.toLowerCase();
  return exts.some((ext) => lower.includes(ext));
}

const MediaPreview: React.FC<MediaPreviewProps> = ({
  src,
  alt,
  className = "",
  poster,
  autoPlay = true,
}) => {
  const url = normalizeSrc(src);

  if (!url) {
    return (
      <div className={`relative w-full h-[200px]`}>
        <img
          src="/assets/images/property-default.svg"
          alt={alt || "default media"}
          className={`w-full h-full object-cover ${className}`}
        />
      </div>
    );
  }

  const isVideo = hasExtension(url, videoFormats);
  const isImage = hasExtension(url, imageFormats);

  return (
    <div className={`relative w-full h-[200px]`}>
      {isVideo ? (
        <video
          src={url}
          poster={poster}
          className={`w-full h-full object-cover ${className}`}
          muted
          loop
          playsInline
          autoPlay={autoPlay}
        />
      ) : isImage ? (
        <img
          src={url}
          alt={alt || "media preview"}
          className={`w-full h-full object-cover ${className}`}
        />
      ) : (
        <img
          src="/assets/images/property-default.svg"
          alt={alt || "default media"}
          className={`w-full h-full object-cover ${className}`}
        />
      )}
    </div>
  );
};

export default MediaPreview;
